const clearLocalStorage = () => localStorage.clear();
const clearSessionStorage = () => sessionStorage.clear();

const clearAllStorage = () => {
    clearLocalStorage();
    clearSessionStorage();
}

export default clearAllStorage;